import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import { faFilePdf as farFilePdf, faTrashAlt as farTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faDownload as fasDownload, faFilePdf as fasFilePdf, faTrashAlt as fasTrashAlt } from '@fortawesome/free-solid-svg-icons';

export default () =>
    library.add(
        fasDownload,
        fasFilePdf,
        farFilePdf,
        fasTrashAlt,
        farTrashAlt,
    );
